function MFREntrataSingleFloorPlan(index, element) {
  this.$element = $(element)

  this.selectors = {
    slider: ".slider-enabled",
    messageContainer: "[data-single-entrata-concession]",
    postContainer: ".blog-post-content"
  }

  this.floorplan = {
    image: ".slide-item:first-child",
    availability: ".dynamic-availability",
    name: ".title",
    price: ".price",
    discounted_price: ".discounted",
    excerpt: ".excerpt",
    ctas: ".ctas"
  }

  this.init()
}

MFREntrataSingleFloorPlan.prototype = Object.assign({}, MFREntrataSingleFloorPlan.prototype, {
  init: function () {
    this.$floorplanID = this.$element.find(this.selectors.postContainer).data('floorplan')
    
    this.$slider = this.$element.find(this.selectors.slider)
    this.$messageContainer = this.$element.find(this.selectors.messageContainer)

    this.$image = this.$element.find(this.floorplan.image)
    this.$availability = this.$element.find(this.floorplan.availability)
    this.$name = this.$element.find(this.floorplan.name)
    this.$price = this.$element.find(this.floorplan.price)
    this.$price_wrapper = this.$price.parents('.pricing-wrapper')
    this.$discounted_price = this.$element.find(this.floorplan.discounted_price)
    this.$excerpt = this.$element.find(this.floorplan.excerpt)
    this.$ctas = this.$element.find(this.floorplan.ctas)

    $(window).on("load", this.__handleInitializaton.bind(this))
  },

  __handleInitializaton: function() {
    this.__handleSliderInit()
    this.__handleContentUpdate()
    this.__handleDiscountConcessionMessage()
  },

  __handleContentUpdate: function() {
    const propertyNameFormatted = window.propertyData.name.replace(/\s+/g, '-').toLowerCase()

    const floorplanID = Number(this.$floorplanID)
    const $this = this

    $.ajax({
      url: `/wp-content/themes/alden-properties/local-json/${propertyNameFormatted}/entrata-data.json`,
      type: 'get',
      dataType: 'json',
      success: function (data) {
        if (!data) return
  
        if (data.response.code === 200) {
          const getFloorPlans = data.response.result.FloorPlans.FloorPlan
          const getFloorPlanData = getFloorPlans.filter(item => item.Identification.IDValue === floorplanID)
  
          if (!getFloorPlanData) return

          let floorplanObject = getFloorPlanData[0],
                image = floorplanObject.File[0].Src,
                availability = floorplanObject.Comment,
                name = floorplanObject.Name,
                price = floorplanObject.MarketRent['@attributes'].Min,
                color = floorplanObject.Comment,
                sqft = "",
                bedroom = "",
                bathroom = "",
                excerpt = ""

          const colorSchemes = window.propertyData.color_schemes

          if (floorplanObject?.Room[0]?.Count !== undefined) {
            bedroom = floorplanObject.Room[0].Count
            excerpt += `${bedroom > 0 ? bedroom + ' Bedroom / ' : ''}`
          }
    
          if (floorplanObject?.Room[1]?.Count !== undefined) {
            bathroom = floorplanObject.Room[1].Count
            excerpt += ` ${bathroom} Bathroom`
          }
    
          if (floorplanObject?.SquareFeet?.['@attributes']?.Max !== undefined) {
            sqft = floorplanObject.SquareFeet['@attributes'].Max
            excerpt += ` / ${sqft} sq. ft.`
          }

          const reserveButtonHTML = () => {
            if (!window.enableDynamicCta) return

            const reserveButton = window.ctas[0].reserve
            $this.$ctas.prepend(`<a href="${reserveButton.url}" class="button style--large primary_button">${reserveButton.name}</a>`)
          }

          name && $this.$name.text(name)
          availability && $this.$availability.text(availability)

          if (price) {
            const discounted_price = $this.$discounted_price.data("price")
           
            if (discounted_price > price) {
              $this.$price.parent().addClass("switch-prices")
            }

            if ($this.$price_wrapper.length > 0) {
              $this.$price.text(`$${price}/${$this.$price_wrapper.data('delimiter')}`)
            } else {
              $this.$price.text(`$${price}/Month`) 
            }
          }

          if (image) {
            $(`<div class="slide-item"><img class="image-contain" loading="lazy" src="${image}" /></div>`).insertBefore($this.$image)
          }

          if (bedroom || bathroom || sqft) {
            $this.$excerpt.html(excerpt)
          }

          if (color == "" || color == undefined || !color) return

          const formatColor = color.toLowerCase()

          if (formatColor.includes('sold')) {
            $this.$availability.css('color', colorSchemes.sold_out)

            if (!window.enableDynamicCta) return

            const waitlistButton = window.ctas[0].waitlist
            if (waitlistButton.url.charAt(0) === '#') {
              $this.$ctas.prepend(`<button data-open="${waitlistButton.url.replace('#', '')}" type="button" class="button style--large primary_button">${waitlistButton.name}</button>`)
            } else {
              $this.$ctas.prepend(`<a href="${waitlistButton.url}" type="button" class="button style--large primary_button">${waitlistButton.name}</a>`)
            }
            
            return
          }

          if (formatColor.includes('available')) {
            $this.$availability.css('color', colorSchemes.available)
            reserveButtonHTML()
            return
          }

          if (!formatColor.includes('available') && !color.includes('sold')) {
            $this.$availability.css('color', colorSchemes.other)
            reserveButtonHTML()
            return
          }
        }
      }
    }) 
  },

  __handleDiscountConcessionMessage: function() {
    const getSpecials = window.getSpecials

    if ( getSpecials && getSpecials.response.code === 200 && this.$messageContainer.length > 0 && (typeof getSpecials.response.result.PhysicalProperty.Property.Floorplan != "undefined") ) {
      const specificConcessions = getSpecials.response.result.PhysicalProperty.Property.Floorplan

      if (typeof specificConcessions != "undefined") {
        const getConcessionMessage = specificConcessions.filter((item) => Number(item.Identification.IDValue) === Number(this.$floorplanID))
        if (getConcessionMessage.length > 0) {
          if (typeof getConcessionMessage[0].Concession[0].DescriptionBody == "string") {
            this.$messageContainer.text(getConcessionMessage[0].Concession[0].DescriptionBody)
          } else {
            this.$messageContainer.text(getConcessionMessage[0].Concession[0].DescriptionHeader)
          }
        }
      }
    }
  },

  __handleSliderInit: function() {
    setTimeout(() => {
      this.$slider.flickity({ wrapAround: true })
      window.flickityButtonArrowChange()
    }, 1000)
  }
})